module.exports = __webpack_public_path__ + "img/norrtag-läkarintyg.b1c07cd8.png";